import { useEffect, useState } from "react";

import { Button } from "../../components/base/Button";
import Form from "../../components/base/Form/Form";
import { FormSelect } from "../../components/base/Form/FormSelect";
import { enumToSelectOptions } from "./../../utils/enumToKeyValue";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { FormTextField } from "../../components/base/Form/FormTextField";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { UseFormReturn } from "react-hook-form";
import { CreateApplicationFormFields } from "../../models/Application/CreateApplication";
import {
  ApplicationStatus,
  ApplicationVisability,
} from "../../models/Application/Application";
import { FormToggle } from "../../components/base/Form/FormToggle";
import useApplicationMutations from "../../data/Application/useApplicationMutations";

export function NewApplication() {
  const { create } = useApplicationMutations();
  const { setInfo } = usePageNameContext();
  const [submitting, setSubmitting] = useState(false);

  const createApplication = (data: CreateApplicationFormFields) => {
    setSubmitting(true);
    create.mutate(
      {
        ...data,
        status: parseInt(data.status as unknown as string),
        visability: parseInt(data.visability as unknown as string),
      },
      {
        onSettled: () => {
          setSubmitting(false);
        },
      }
    );
  };

  useEffect(() => {
    setInfo({
      name: "New Application",
      desc: "Create a new application.",
      pageTitle: "New Application",
    });
  }, []);

  return (
    <div className="bg-white rounded shadow p-4">
      {submitting ? (
        <div className="py-8">
          <LoadingWheel />
        </div>
      ) : (
        <Form<CreateApplicationFormFields>
          onSubmit={createApplication}
          className="grid grid-cols-1 gap-y-4 md:w-3/4 md:grid-cols-2 md:gap-4"
        >
          {({
            register,
            control,
          }: UseFormReturn<CreateApplicationFormFields>) => (
            <>
              <div className="col-span-2 grid grid-cols-1 gap-y-4 md:gap-4 md:px-4 md:grid-cols-2">
                <div className="md:col-span-2 border-b">
                  <p className="text-base font-medium text-gray-600 font-stick pb-2">
                    Basic Information
                  </p>
                </div>
                <FormTextField
                  {...register("name", { required: true })}
                  placeholder="Hubspot"
                  label="Application Name"
                />
                <FormSelect {...register("status")} label="Status">
                  {enumToSelectOptions(ApplicationStatus).map((status) => (
                    <option value={status.value}>{status.label}</option>
                  ))}
                </FormSelect>
                <FormSelect {...register("visability")} label="Visability">
                  {enumToSelectOptions(ApplicationVisability).map((status) => (
                    <option value={status.value}>{status.label}</option>
                  ))}
                </FormSelect>
                <div />
                <div className="mt-2">
                  <FormToggle<CreateApplicationFormFields>
                    control={control}
                    name="system"
                    toggleProps={{ label: "System Application" }}
                  />
                </div>
                <div className="mt-2">
                  <FormToggle<CreateApplicationFormFields>
                    control={control}
                    name="allowSignup"
                    toggleProps={{ label: "Allow Sign Up" }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-y-4 md:col-span-2 md:gap-4 md:px-4 md:pb-4 md:grid-cols-2">
                <div className="col-span-2 mt-4 pt-4 grid grid-cols-4 gap-4 border-t">
                  <Button type="submit">Create Application</Button>
                  <Button type="reset" variant="outlined">
                    Reset
                  </Button>
                </div>
              </div>
            </>
          )}
        </Form>
      )}
    </div>
  );
}
